import request from "../utils/axios";

export const getSellers = (params) => {
  return request({ method: "GET", url: "/sellers", params });
};

export const getSeller = (id) => {
  return request({ method: "GET", url: `/sellers/${id}` });
};

export const getSellerTerminals = (id) => {
  return request({ method: "GET", url: `/sellers/${id}/terminals` });
};

export const getSellerAddresses = (id) => {
  return request({ method: "GET", url: `/sellers/${id}/addresses` });
};

export const bindTerminalToSeller = (sellerId, data) => {
  return request({
    method: "POST",
    url: `/sellers/${sellerId}/terminals`,
    data,
  });
};

export const bindCardToSeller = (sellerId, data) => {
  return request({
    method: "POST",
    url: `/sellers/${sellerId}/card-numbers`,
    data,
  });
};

export const bindAddressToSeller = (sellerId, data) => {
  return request({
    method: "POST",
    url: `/sellers/${sellerId}/addresses`,
    data,
  });
};

export const removeCardFromSeller = (sellerId, cardNumberId) => {
  return request({
    method: "DELETE",
    url: `/sellers/${sellerId}/card-numbers/${cardNumberId}`,
  });
};

export const removeAddressFromSeller = (sellerId, addressId) => {
  return request({
    method: "DELETE",
    url: `/sellers/${sellerId}/addresses/${addressId}`,
  });
};

export const removeTerminalFromSeller = (sellerId, terminalId) => {
  return request({
    method: "DELETE",
    url: `/sellers/${sellerId}/terminals/${terminalId}`,
  });
};

export const getTransactions = (params) => {
  return request({ method: "GET", url: "/transactions", params });
};

export const sellerStatistics = (sellerId) => {
  return request({
    method: "GET",
    url: `/analytics/list/sellers/${sellerId}/diagram`,
  });
};

export const createSeller = (data) => {
  return request({ method: "POST", url: "/sellers", data });
};

export const editSeller = (data, id) => {
  return request({ method: "PUT", url: `/sellers/${id}`, data });
};

export const deleteSeller = (id) => {
  return request({ method: "DELETE", url: `/sellers/${id}` });
};

export const getSellerTransactions = (params) => {
  return request({ method: "GET", url: "/payments", params });
};

export const getCardTransactions = (params) => {
  return request({ method: "GET", url: "/bo-gate-transactions", params });
};

export const retryPayment = (paymentId) => {
  return request({ method: "PUT", url: `/payments/${paymentId}` });
};
